import { Component, Input, Output, EventEmitter, OnChanges, ElementRef, AfterViewInit, ViewChild } from '@angular/core';
import { FunCollectionService } from '../../common/common-functions/fun-collection.service';
import { fromEvent } from 'rxjs';
import { switchMap, takeUntil, pairwise } from 'rxjs/operators';
let cx: CanvasRenderingContext2D;
@Component({
  selector: 'app-canvas-image-editor',
  templateUrl: './canvas-image-editor.component.html',
  styleUrls: ['./canvas-image-editor.component.scss']
})
export class CanvasImageEditorComponent implements AfterViewInit, OnChanges {
@Input() canvas_image_edit_obj;
@Input() public width = 400;
@Input() public height = 400;
@Output() saveUpdatedImage = new EventEmitter();

pencile_size=3;
pencile_color='black';
  constructor(public fcs:FunCollectionService)
  {

  }
  /**
   * Key used to enable/disable upgraded design.
   */
  @Input() switchDesign: boolean;

  @ViewChild('canvas_edit_image') public canvas: ElementRef;



  ngOnChanges(): void {
    console.log(this.canvas_image_edit_obj);
    this.setImageToCanvas();
    // this.imageToBase64(this.canvas_image_edit_obj);
  }

  resetModal(): void {
    this.fcs.resetCanvasImageEditObj();
  }




  public ngAfterViewInit(): void {
    const canvasEl: HTMLCanvasElement = this.canvas.nativeElement;
    cx = canvasEl.getContext('2d');

    canvasEl.width = this.width;
    canvasEl.height = this.height;

    cx.lineWidth = this.pencile_size;
    cx.lineCap = 'round';
    cx.strokeStyle = '#000';

    this.captureEvents(canvasEl);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private captureEvents(canvasEl: HTMLCanvasElement): any {
    fromEvent(canvasEl, 'mousedown')
      .pipe(
        switchMap(() => {
          return fromEvent(canvasEl, 'mousemove')
            .pipe(
              takeUntil(fromEvent(canvasEl, 'mouseup')),
              takeUntil(fromEvent(canvasEl, 'mouseleave')),
              pairwise() /* Return the previous and last values as array */
            );
        })
      ).subscribe((res: [MouseEvent, MouseEvent]) => {
        const rect = canvasEl.getBoundingClientRect();

        const prevPos = {
          x: res[0].clientX - rect.left,
          y: res[0].clientY - rect.top
        };

        const currentPos = {
          x: res[1].clientX - rect.left,
          y: res[1].clientY - rect.top
        };
        this.drawOnCanvas(prevPos, currentPos);
      });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private drawOnCanvas(prevPos: { x: number, y: number }, currentPos: { x: number, y: number }): any{
    if (!cx) { return; }

    cx.beginPath();

    if (prevPos) {
      cx.moveTo(prevPos.x, prevPos.y); // from
      cx.lineTo(currentPos.x, currentPos.y);
      cx.stroke();
    }
  }


  setImageToCanvas(): void {
    const base_image = new Image();
    base_image.crossOrigin = 'Anonymous';
    base_image.src = this.canvas_image_edit_obj.base64Str;
    base_image.onload = () => {
      const x = 0;
      const y = 0;
      const width = 400;
      const height = 400;
      cx.drawImage(base_image, x, y, width, height);
    };

  }




  saveImage(): void {
    const canvas = <HTMLCanvasElement>document.getElementById('canvas_edit_image');
    this.saveUpdatedImage.emit(canvas.toDataURL());
  }

  setPencilSize(size): void {
    this.pencile_size = size;
    cx.lineWidth = size;
  }

  selectColor(color): void {
    this.pencile_color = color;
    cx.strokeStyle = color;
  }
}
